// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1TjLUHc43kbLmFKn4qrpCn","top":"trax0TaGzkVUWi-TfSNao","brand":"BrLIyIzrNYSEFhQ3T3vLL","social":"_1TqvMWvLlLipT-yhsx54Yt","mails":"_1ETSslM3BKbGBIDGYai0xr","qrcode":"_3fnAhC3c60trv2lpoVGwV9","bottom":"_1Y5kQPAvZ7N0BkVYomnB49"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/footer/FooterMobile.module.css
// module id = 829
// module chunks = 0